import React, { useState, useEffect, useRef } from "react";
import ReactToPrint from "react-to-print";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Table,
  ButtonGroup,
} from "reactstrap";
import moment from "moment";
import * as Icons from "react-feather";
import { urlAPI, getUser, getToken } from "utility/Common";
import { handleActionLogout } from "redux/actions/auth/logoutActions";
import Axios from "axios";
import { useDispatch } from "react-redux";
import NumberFormat from "react-number-format";
import ReactExport from "react-export-excel";

const headerStyle = {
  fontSize: "12px",
  color: "black",
  margin: "1px 1px 1px 1px",
};
const bodyStyle = {
  fontSize: "10px",
  color: "black",
  margin: "1px 1px 1px 1px",
};
const containerStyle = {
  padding: "5px 1px 5px 1px",
};

class ComponentToPrint extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const data = this.props.dataPrint;
    const sbu = this.props.sbu;

    console.log("dataPrint", data);
    return (
      <div style={containerStyle}>
        <p style={{ ...headerStyle, textAlign: "center" }}>
          <strong>LAPORAN PERSEDIAAN BARANG SINF</strong>
        </p>
        <p style={{ ...headerStyle, textAlign: "center" }}>
          <strong>
            {sbu === "RSPG"
              ? "RUMAH SAKIT PETROKIMIA GRESIK"
              : sbu === "KALIMANTAN"
              ? "KLINIK SATELIT KALIMANTAN"
              : sbu === "GRAHU"
              ? "RUMAH SAKIT GRHA HUSADA"
              : sbu === "PPK1"
              ? "KLINIK PPK I PT PETROKIMIA GRESIK"
              : sbu === "DRIYO"
              ? "RUMAH SAKIT PETROKIMIA GRESIK DRIYOREJO"
              : sbu === "WA"
              ? "KLINIK PPK I WRINGINANOM GRESIK"
              : "PETRO GRAHA MEDIKA"}
          </strong>
        </p>
        <br />
        <Table borderless={true} size="sm">
          <tbody>
            <tr>
              <td style={{ width: "10%", verticalAlign: "top" }}>
                <p style={bodyStyle}>PERIODE</p>
                <p style={bodyStyle}>UNIT LAYANAN</p>
              </td>
              <td style={{ width: "40%", verticalAlign: "top" }}>
                <p style={bodyStyle}>: {moment()?.format("YYYY-MM")}</p>
                <p style={bodyStyle}>
                  :{" "}
                  {data &&
                    data[0]?.kodeunit.trim() + " - " + data[0]?.namaunit.trim()}
                </p>
              </td>
              <td style={{ width: "50%", verticalAlign: "top" }}>
                <br />
                <p style={{ ...bodyStyle, textAlign: "right" }}>
                  {moment().format("DD/MM/YYYY HH:mm:ss")}
                </p>
              </td>
            </tr>
          </tbody>
        </Table>
        <br />
        <Table bordered={true} style={{ border: "1px solid black" }}>
          <thead>
            <tr>
              <th
                style={{
                  width: "4%",
                  verticalAlign: "middle",
                  border: "1px solid black",
                }}
                rowSpan="2"
              >
                <p style={{ ...bodyStyle, textAlign: "center" }}>
                  <strong>No.</strong>
                </p>
              </th>
              <th
                style={{
                  width: "6%",
                  verticalAlign: "middle",
                  border: "1px solid black",
                }}
                rowSpan="2"
              >
                <p style={{ ...bodyStyle, textAlign: "center" }}>
                  <strong>Kode Barang</strong>
                </p>
              </th>
              <th
                style={{
                  width: "22%",
                  verticalAlign: "middle",
                  border: "1px solid black",
                }}
                rowSpan="2"
              >
                <p style={{ ...bodyStyle, textAlign: "center" }}>
                  <strong>Nama Barang</strong>
                </p>
              </th>
              <th
                style={{
                  width: "4%",
                  verticalAlign: "middle",
                  border: "1px solid black",
                }}
                rowSpan="2"
              >
                <p style={{ ...bodyStyle, textAlign: "center" }}>
                  <strong>Stk Awal</strong>
                </p>
              </th>
              <th
                style={{
                  width: "5%",
                  verticalAlign: "middle",
                  border: "1px solid black",
                }}
                rowSpan="2"
              >
                <p style={{ ...bodyStyle, textAlign: "center" }}>
                  <strong>Harga</strong>
                </p>
              </th>
              <th
                style={{
                  width: "10%",
                  verticalAlign: "middle",
                  border: "1px solid black",
                }}
                rowSpan="2"
              >
                <p style={{ ...bodyStyle, textAlign: "center" }}>
                  <strong>Nilai Awal</strong>
                </p>
              </th>
              <th
                style={{
                  width: "12%",
                  verticalAlign: "middle",
                  border: "1px solid black",
                }}
                colSpan="2"
              >
                <p style={{ ...bodyStyle, textAlign: "center" }}>
                  <strong>Stok Masuk</strong>
                </p>
              </th>
              <th
                style={{
                  width: "15%",
                  verticalAlign: "middle",
                  border: "1px solid black",
                }}
                colSpan="3"
              >
                <p style={{ ...bodyStyle, textAlign: "center" }}>
                  <strong>Stok Keluar</strong>
                </p>
              </th>
              <th
                style={{
                  width: "6%",
                  verticalAlign: "middle",
                  border: "1px solid black",
                }}
                rowSpan="2"
              >
                <p style={{ ...bodyStyle, textAlign: "center" }}>
                  <strong>Stok Akhir</strong>
                </p>
              </th>
              <th
                style={{
                  width: "6%",
                  verticalAlign: "middle",
                  border: "1px solid black",
                }}
                rowSpan="2"
              >
                <p style={{ ...bodyStyle, textAlign: "center" }}>
                  <strong>Harga</strong>
                </p>
              </th>
              <th
                style={{
                  width: "10%",
                  verticalAlign: "middle",
                  border: "1px solid black",
                }}
                rowSpan="2"
              >
                <p style={{ ...bodyStyle, textAlign: "center" }}>
                  <strong>Nilai Persediaan</strong>
                </p>
              </th>
            </tr>
            <tr>
              <th
                style={{
                  width: "6%",
                  verticalAlign: "middle",
                  border: "1px solid black",
                }}
              >
                <p style={{ ...bodyStyle, textAlign: "center" }}>
                  <strong>Pembelian</strong>
                </p>
              </th>
              <th
                style={{
                  width: "6%",
                  verticalAlign: "middle",
                  border: "1px solid black",
                }}
              >
                <p style={{ ...bodyStyle, textAlign: "center" }}>
                  <strong>Transfer</strong>
                </p>
              </th>
              <th
                style={{
                  width: "5%",
                  verticalAlign: "middle",
                  border: "1px solid black",
                }}
              >
                <p style={{ ...bodyStyle, textAlign: "center" }}>
                  <strong>Jual</strong>
                </p>
              </th>
              <th
                style={{
                  width: "5%",
                  verticalAlign: "middle",
                  border: "1px solid black",
                }}
              >
                <p style={{ ...bodyStyle, textAlign: "center" }}>
                  <strong>Pakai</strong>
                </p>
              </th>
              <th
                style={{
                  width: "5%",
                  verticalAlign: "middle",
                  border: "1px solid black",
                }}
              >
                <p style={{ ...bodyStyle, textAlign: "center" }}>
                  <strong>Transfer</strong>
                </p>
              </th>
            </tr>
          </thead>
          <tbody>
            {data &&
              data?.map((obj, index) => (
                <tr key={index}>
                  <td
                    style={{
                      verticalAlign: "top",
                      border: "1px solid black",
                    }}
                  >
                    <p style={{ ...bodyStyle, textAlign: "center" }}>
                      {index + 1}
                    </p>
                  </td>
                  <td
                    style={{
                      verticalAlign: "top",
                      border: "1px solid black",
                    }}
                  >
                    <p style={{ ...bodyStyle, textAlign: "center" }}>
                      {obj?.kodebarang}
                    </p>
                  </td>
                  <td
                    style={{
                      verticalAlign: "top",
                      border: "1px solid black",
                    }}
                  >
                    <p style={{ ...bodyStyle, textAlign: "left" }}>
                      {obj?.namabarang}
                    </p>
                  </td>
                  <td
                    style={{
                      verticalAlign: "top",
                      border: "1px solid black",
                    }}
                  >
                    <p style={{ ...bodyStyle, textAlign: "center" }}>
                      <NumberFormat
                        value={Number(obj?.stokawal)}
                        displayType={"text"}
                        decimalSeparator={","}
                        thousandSeparator={"."}
                        decimalScale={0}
                        fixedDecimalScale={true}
                      />
                    </p>
                  </td>
                  <td
                    style={{
                      verticalAlign: "top",
                      border: "1px solid black",
                    }}
                  >
                    <p style={{ ...bodyStyle, textAlign: "center" }}>
                      <NumberFormat
                        value={Number(obj?.harga)}
                        displayType={"text"}
                        decimalSeparator={","}
                        thousandSeparator={"."}
                        decimalScale={0}
                        fixedDecimalScale={true}
                      />
                    </p>
                  </td>
                  <td
                    style={{
                      verticalAlign: "top",
                      border: "1px solid black",
                    }}
                  >
                    <p style={{ ...bodyStyle, textAlign: "center" }}>
                      <NumberFormat
                        value={Number(obj?.nilaiawal)}
                        displayType={"text"}
                        decimalSeparator={","}
                        thousandSeparator={"."}
                        decimalScale={0}
                        fixedDecimalScale={true}
                      />
                    </p>
                  </td>
                  <td
                    style={{
                      verticalAlign: "top",
                      border: "1px solid black",
                    }}
                  >
                    <p style={{ ...bodyStyle, textAlign: "center" }}>
                      <NumberFormat
                        value={Number(obj?.pembelian)}
                        displayType={"text"}
                        decimalSeparator={","}
                        thousandSeparator={"."}
                        decimalScale={0}
                        fixedDecimalScale={true}
                      />
                    </p>
                  </td>
                  <td
                    style={{
                      verticalAlign: "top",
                      border: "1px solid black",
                    }}
                  >
                    <p style={{ ...bodyStyle, textAlign: "center" }}>
                      <NumberFormat
                        value={Number(obj?.transfermasuk)}
                        displayType={"text"}
                        decimalSeparator={","}
                        thousandSeparator={"."}
                        decimalScale={0}
                        fixedDecimalScale={true}
                      />
                    </p>
                  </td>
                  <td
                    style={{
                      verticalAlign: "top",
                      border: "1px solid black",
                    }}
                  >
                    <p style={{ ...bodyStyle, textAlign: "center" }}>
                      <NumberFormat
                        value={Number(obj?.jual)}
                        displayType={"text"}
                        decimalSeparator={","}
                        thousandSeparator={"."}
                        decimalScale={0}
                        fixedDecimalScale={true}
                      />
                    </p>
                  </td>
                  <td
                    style={{
                      verticalAlign: "top",
                      border: "1px solid black",
                    }}
                  >
                    <p style={{ ...bodyStyle, textAlign: "center" }}>
                      <NumberFormat
                        value={Number(obj?.pemakaian)}
                        displayType={"text"}
                        decimalSeparator={","}
                        thousandSeparator={"."}
                        decimalScale={0}
                        fixedDecimalScale={true}
                      />
                    </p>
                  </td>
                  <td
                    style={{
                      verticalAlign: "top",
                      border: "1px solid black",
                    }}
                  >
                    <p style={{ ...bodyStyle, textAlign: "center" }}>
                      <NumberFormat
                        value={Number(obj?.transferkeluar)}
                        displayType={"text"}
                        decimalSeparator={","}
                        thousandSeparator={"."}
                        decimalScale={0}
                        fixedDecimalScale={true}
                      />
                    </p>
                  </td>
                  <td
                    style={{
                      verticalAlign: "top",
                      border: "1px solid black",
                    }}
                  >
                    <p style={{ ...bodyStyle, textAlign: "center" }}>
                      <NumberFormat
                        value={Number(obj?.stokakhir)}
                        displayType={"text"}
                        decimalSeparator={","}
                        thousandSeparator={"."}
                        decimalScale={0}
                        fixedDecimalScale={true}
                      />
                    </p>
                  </td>
                  <td
                    style={{
                      verticalAlign: "top",
                      border: "1px solid black",
                    }}
                  >
                    <p style={{ ...bodyStyle, textAlign: "center" }}>
                      <NumberFormat
                        value={Number(obj?.harga)}
                        displayType={"text"}
                        decimalSeparator={","}
                        thousandSeparator={"."}
                        decimalScale={0}
                        fixedDecimalScale={true}
                      />
                    </p>
                  </td>
                  <td
                    style={{
                      verticalAlign: "top",
                      border: "1px solid black",
                    }}
                  >
                    <p style={{ ...bodyStyle, textAlign: "center" }}>
                      <NumberFormat
                        value={Number(obj?.nilaipersediaan)}
                        displayType={"text"}
                        decimalSeparator={","}
                        thousandSeparator={"."}
                        decimalScale={0}
                        fixedDecimalScale={true}
                      />
                    </p>
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
      </div>
    );
  }
}

export default function PrintRekapPersediaan(props) {
  const { open, filter, handleClose } = props;
  const componentRef = useRef();
  const dispatch = useDispatch();
  const [dataPrint, setDataPrint] = useState(null);
  const [loading, setLoading] = useState(false);
  const ExcelFile = ReactExport.ExcelFile;
  const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
  const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

  useEffect(() => {
    if (open && filter) {
      setLoading(true);
      fetchData();
    }
  }, [open]);

  const fetchData = () => {
    Axios.get(
      urlAPI +
        "/v1/ReportInventory/SINFlappersediaanunit_rekappersediaan?params=" +
        JSON.stringify({
          ...filter,
          periode: moment().subtract(1, "months").format("YYYY-MM"),
        }),
      {
        headers: {
          Authorization: "Bearer " + getToken(),
        },
      }
    )
      .then((response) => {
        if (response?.data?.result?.rows?.length > 0) {
          setDataPrint(response?.data?.result?.rows);
        } else {
          setDataPrint([]);
        }
        setLoading(false);
      })
      .catch((err) => {
        if (err.response?.statusText === "Unauthorized") {
          setLoading(false);
          dispatch(handleActionLogout());
        } else {
          dispatch({
            type: "FILL_GAGAL",
            gagal: true,
            pesan: err?.response?.data?.message,
          });
          setLoading(false);
        }
      });
  };

  const printStyle = `
 @media all {
  .page-break {
    display: none;
  }
}

@media print {
  html, body {
    height: initial !important;
    overflow: initial !important;
    -webkit-print-color-adjust: exact;
  }
}

@media print {
  .page-break {
    margin-top: 1rem;
    display: block;
    page-break-before: auto;
  }
  @page {
  size: landscape;
}
}

@page {
  size: landscape;
  margin: 20mm;
}
  `;

  return (
    <Modal
      isOpen={open}
      toggle={handleClose}
      className="modal-dialog-centered modal-xl"
      backdrop="static"
    >
      <ModalHeader toggle={handleClose}>Data Preview</ModalHeader>
      <ModalBody>
        <ButtonGroup style={{ width: "100%" }}>
          <ExcelFile
            element={
              <Button
                className="btn"
                color="success"
                // style={{ width: "50%" }}
              >
                <Icons.Download size={18} /> Download Excel
              </Button>
            }
            filename={
              "Laporan Persediaan Perunit - Rekap Persediaan | " +
              moment().format("DD/MM/YYYY")
            }
          >
            <ExcelSheet data={dataPrint} name="Rekap Persediaan">
              {dataPrint?.length > 0 &&
                Object.keys(dataPrint[0]).map(function (key, index) {
                  return <ExcelColumn label={key} value={key} />;
                })}
            </ExcelSheet>
          </ExcelFile>
          &nbsp;
          <ReactToPrint
            trigger={() => (
              <Button
                color="primary"
                // style={{ width: "50%" }}
                disabled={loading}
                // size="sm"
              >
                <Icons.Printer size={14} /> Print
              </Button>
            )}
            content={() => componentRef.current}
            pageStyle={printStyle}
          />
        </ButtonGroup>

        <hr />
        {loading ? (
          <div className="text-center">
            <h4>Loading...</h4>
          </div>
        ) : (
          <ComponentToPrint
            ref={componentRef}
            dataPrint={dataPrint}
            sbu={getUser()?.sbu}
          />
        )}
      </ModalBody>
    </Modal>
  );
}
